// test1217
(1217 && 0);
